import Link from 'next/link';

import ExportedImage from '@/components/shared/ExportedImage';

import footerArrow from '/public/images/lp/komodo-wallet/footer-arrow-mobile.svg';

// next/link rather than a plain anchor: these hrefs are root-relative site
// routes, and only next/link applies the basePath the site is served under.
// Absolute URLs passed through here are left untouched, as before.
export const FooterItem = ({ href, text, arrow }) => {
  return !arrow ? (
    <Link href={href} className={`flex items-start`}>
      <p className='text-sm font-medium text-slate-300'>{text}</p>
    </Link>
  ) : (
    <Link href={href} className={`flex items-start`}>
      <span className='text-sm font-medium text-slate-300'>
        {text}{' '}
        <ExportedImage
          placeholder='empty'
          alt='footer-arrow'
          src={footerArrow}
          className='ml-1.5 inline h-auto w-[10px] align-middle'
        />
      </span>
    </Link>
  );
};
